// Dashboard-Plugin Registry
var vcDashboardRegistry = {

    _plugins: {},

    register: function (type, plugin) {
        if (!type || !plugin || typeof plugin.render !== "function") {
            console.error("vcDashboardRegistry: Plugin muss einen 'type' und eine 'render'-Funktion haben.");
            return;
        }
        this._plugins[type] = plugin;
    },

    get: function (type) {
        return this._plugins[type] || null;
    },

    getAll: function () {
        return this._plugins;
    },

    hasType: function (type) {
        return this._plugins.hasOwnProperty(type);
    },

    render: function (type, $container, item) {
        var plugin = this.get(type);
        if (plugin) {
            plugin.render($container, item);
        } else {
            $container.html("<p>Unbekannter Dashboard-Typ: " + type + "</p>");
        }
    }
};
